import { COULEURS } from './styles.js';

/**
 * Indicateur de réseau (M05, UX-22). Il dit où en sont les envois, avec les mots de la synthèse (correction n° 9) :
 * rien ne se perd, tout part dès que le réseau revient ou à la prochaine ouverture de la page.
 */
export interface EtatReseau {
  enLigne: boolean;
}

export type EvenementReseau = { type: 'online' } | { type: 'offline' };

export function reducerReseau(_etat: EtatReseau, evenement: EvenementReseau): EtatReseau {
  return { enLigne: evenement.type === 'online' };
}

export const lireEnLigne = (navigateur: { onLine: boolean } | undefined): boolean => navigateur?.onLine ?? true;

const envois = (n: number): string => `${n} ${n > 1 ? 'envois' : 'envoi'}`;

export function libelleReseau({ enLigne, enAttente }: { enLigne: boolean; enAttente: number }): string | null {
  if (enLigne) return enAttente > 0 ? `Réseau rétabli. ${envois(enAttente)} ${enAttente > 1 ? 'partent' : 'part'} en ce moment.` : null;
  const base =
    'Vous êtes hors ligne. Votre saisie est conservée sur cet appareil. Elle partira dès que le réseau revient, ou à votre prochaine ouverture de la page.';
  return enAttente > 0 ? `${base} ${envois(enAttente)} en attente.` : base;
}

/** Côté client (portail, externes) l'indicateur s'adresse aux héritiers : 18 px au moins (UX-20). */
export function IndicateurHorsLigne({ enLigne, enAttente, client = false }: { enLigne: boolean; enAttente: number; client?: boolean }) {
  const libelle = libelleReseau({ enLigne, enAttente });
  if (!libelle) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-indicateur="reseau"
      style={{ padding: '8px 16px', background: COULEURS.ambreFond, color: COULEURS.ambre, fontSize: client ? 18 : 16, lineHeight: 1.5 }}
    >
      {libelle}
    </div>
  );
}
